controllers.controller('CreditCardSecuredController', [
    '$scope', '$state', '$filter', '$timeout', '$ionicLoading', '$ionicHistory', '$q', 'LocaleService', 'config', 'Validator', 'Storage', 'constants',
    'ServerTimeService', 'Utils', 'UserService', 'API', 'ErrorService', '$cookies',
    function ($scope, $state, $filter, $timeout, $ionicLoading, $ionicHistory, $q, LocaleService, config, Validator, Storage, Const,
              ServerTimeService, Utils, UserService, API, ErrorService, $cookies) {

        LocaleService.wait().then(function (translation) {
            $scope.translation = translation;
        });

        $scope.user = UserService.get();

        $scope.paymentMethods = Storage.get('paymentMethods') || [];

        $scope.constants = Const;

        $scope.depositValue = Storage.get('depositValue');

        $scope.validator = Validator.getPattern;

        $scope.minDate = ServerTimeService.time;

        $scope.creditCard = {
            value: $scope.depositValue.visual,
            holder: $scope.user.firstName + ' ' + $scope.user.lastName
        };
        $scope.paymentPopup = null;

        var paymentRequest = {
            amount: 0,
            currency: $scope.user.activeTradingAccount.currency,
            type: '',
            number: '',
            cvv: '',
            expiryMonth: null,
            expiryYear: null,
            holder: $scope.user.firstName + ' ' + $scope.user.lastName,
            country: $scope.user.country,
            address: $scope.user.address,
            city: $scope.user.city,
            phone: $scope.user.phone,
            state: '',
            postcode: $scope.user.postCode,
            phoneCountryCode: '',
            phoneAreaCode: '',
            secure: true,
            platform: Const.platformById.webMobile
        };

        var cardTypeBlueprint = {
            visaelectron: 'Visa Electron',
            maestro: 'Maestro',
            forbrugsforeningen: '',
            dankort: '',
            visa: 'Visa',
            mastercard: 'MasterCard',
            amex: 'American Express',
            dinersclub: 'Diners Club',
            discover: '',
            unionpay: '',
            jcb: 'JCB'
        };

        $scope.config = {
            digits: 0,
            step: 50,
            min: $scope.depositValue.minimum,
            max: $scope.depositValue.maximum
        };

        $scope.changeStep = config.stepChange;


        $scope.listAmounts = [];

        var result = [];

        Array(5).fill(null).reduce(function (acc, cur, index) {
            var tmp = Math.ceil(acc * Const.depositMultipliers[index]);
            result.push(tmp);
            return tmp;
        }, $scope.depositValue.visual <= $scope.config.min ? $scope.config.min : $scope.depositValue.visual);

        if (result.length > 0) $scope.listAmounts = result;

        $scope.confirm = function (form) {
            if (!form.$valid) return;
            var expiryMonth = $filter('date')($scope.creditCard.date, "MM");
            var expiryYear = $filter('date')($scope.creditCard.date, "yyyy");
            paymentRequest.type = '';
            paymentRequest.number = $scope.creditCard.number;
            paymentRequest.cvv = $scope.creditCard.cvv;
            paymentRequest.expiryMonth = parseInt(expiryMonth, 10);
            paymentRequest.expiryYear = parseInt(expiryYear, 10);
            paymentRequest.holder = $scope.creditCard.holder;
            paymentRequest.amount = parseFloat($scope.creditCard.value);
            paymentRequest.remarketing = $cookies.get('remarketing') || '';
            return doPayment();
        };

        function checkResponse(data) {
            if (data.status !== 1) {
                throw new ErrorService({
                    source: 'CreditCardController',
                    type: Const.error.type.VALIDATION,
                    code: data.code,
                    severity: 'warning',
                    data: {response: data}
                });
            }
            return data;
        }

        function updatePopup(response) {

            return $q(function (resolve, reject) {
                API.subscribe('depositConfirm', clearPayment);
                var popupOptions = 'location=yes,hidden=yes';
                if (window.cordova && window.cordova.InAppBrowser) {
                    if (response.RedirectURL && !response.PostData) {
                        $scope.paymentPopup = window.cordova.InAppBrowser.open(response.RedirectURL, '_blank', popupOptions);
                    } else {
                        $scope.paymentPopup = window.cordova.InAppBrowser.open('templates/deposit-inapp.html', '_blank', popupOptions);
                    }
                }

                $scope.paymentPopup.addEventListener('exit', stop);
                $scope.paymentPopup.addEventListener('loadstop', run);
                $scope.paymentPopup.addEventListener('loaderror', stop);

                function run() {
                    $scope.paymentPopup.show();
                    return response.PostData && postData();
                }

                function stop() {
                    $scope.paymentPopup.close();
                    $scope.paymentPopup.removeEventListener('exit', stop);
                    $scope.paymentPopup.removeEventListener('loadstop', run);
                    $scope.paymentPopup.removeEventListener('loaderror', stop);
                    $scope.paymentPopup = null;
                    reject();
                }

                function clearPayment(confirmResponse) {
                    API.unsubscribe('depositConfirm');
                    $scope.paymentPopup && $scope.paymentPopup.close();
                    try {
                        checkResponse(confirmResponse);
                    } catch (e) {
                        reject(e);
                    }

                    resolve(confirmResponse);
                }

                function postData() {
                    var script = "postData('" + response.RedirectURL + "','" + JSON.stringify(response.PostData) + "')";
                    $scope.paymentPopup.executeScript({code: script});
                }
            });
        }


        $scope.modal = {
            actionText: LocaleService.translation.try_again,
            state: false
        };

        function doPayment() {
            $ionicLoading.show();

            return API.creditCardDeposit(paymentRequest)
                .then(checkResponse)
                .then(function (response) {
                    if (response.RedirectURL && response.RedirectURL.length > 0) {
                        return updatePopup(response);
                    }
                    return response;
                })
                .then(function (response) {
                    $scope.paymentPopup && $scope.paymentPopup.close();
                    $ionicLoading.hide();
                    $cookies.get('remarketing') && $cookies.remove('remarketing');
                    $scope.modal.textTitle = LocaleService.translation.messages.depositSuccess;
                    $scope.modal.isError = false;
                    $scope.modal.actionText = LocaleService.translation.startTrading;
                    $scope.modal.back = 'root.app.assets';

                    $scope.modal.transactionId = response.transactionId;
                    $scope.modal.date = Date.now();
                    $scope.modal.amount = Const.currencySymbols[response.currency] + ' ' + response.amount;
                    $scope.modal.method = 'Credit Card **** ' + (response.creditCardLast4Digits || response.lastDigits);
                    $scope.modal.state = true;
                })
                .catch(function (error) {
                    $ionicLoading.hide();
                    $scope.modal.textTitle = LocaleService.translation.messages.depositFailed;
                    $scope.paymentPopup && $scope.paymentPopup.close();
                    $scope.modal.isError = true;
                    $scope.modal.textContent = LocaleService.translation.messages.depositFailedText;
                    $scope.modal.actionText = $scope.paymentMethods.length > 1 ? LocaleService.translation.try_again : LocaleService.translation.close;
                    $scope.modal.back = $scope.paymentMethods.length > 1 ? 'root.app.wallet' : 'root.app.assets';
                    $scope.modal.state = true;
                })
        }

        function clear() {
            API.unsubscribe('depositConfirm');
            $scope.creditCard = null;
            $scope.depositValue = null;
            $scope.user = null;
            $scope.paymentPopup = null;
            $scope.user = null;
            $ionicHistory.clearHistory();
        }

        $scope.$on('$ionicView.afterLeave', clear);
        $scope.$on('clear', clear);

    }]);
